// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"124":"741304a2","785":"741304a2"}[chunkId] + ".chunk.css";
};